import { TravellersFormData } from '@reward-platform/flights-schemas'

export enum Errors {
  InfantsExceedingAdults = 'InfantsExceedingAdults',
  NoAdultPresentForChild = 'NoAdultPresentForChild',
}

export const validatePassengers = (value: TravellersFormData): Errors | null => {
  let children = 0
  let infants = 0
  let adults = value.adult.quantity

  value.childrenAges.forEach(({ age }) => {
    if (age < 2) {
      infants += 1
    }
    if (age < 15) {
      children += 1
    } else {
      adults += 1
    }
  })

  const totalChildren = children + infants

  if (totalChildren && !adults) {
    return Errors.NoAdultPresentForChild
  }
  if (infants > adults) {
    return Errors.InfantsExceedingAdults
  }
  return null
}
